import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eeca35e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-card" }
const _hoisted_2 = { class: "box-card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_container_info_component = _resolveComponent("container-info-component")!
  const _component_sampling_point_list_component = _resolveComponent("sampling-point-list-component")!
  const _component_station_table_list_component = _resolveComponent("station-table-list-component")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_page_header, {
          content: _ctx.container.name,
          title: "",
          onBack: _ctx.goBack
        }, null, 8, ["content", "onBack"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, { class: "box-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_container_info_component, {
          id: _ctx.id,
          containerData: _ctx.container
        }, null, 8, ["id", "containerData"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_sampling_point_list_component, { containerId: _ctx.id }, null, 8, ["containerId"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_station_table_list_component, { containerId: _ctx.id }, null, 8, ["containerId"])
    ])
  ]))
}